import { render } from "./DropdownItem.vue?vue&type=template&id=09a2f9fa"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=09a2f9fa&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__